import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "google-spreadsheet",
  "use": "google-spreadsheet-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"google-spreadsheet\"><g fill=\"none\" fill-rule=\"evenodd\"><rect fill=\"#009C5D\" width=\"16\" height=\"16\" rx=\"1\" /><path d=\"M8 6V2H6v4H2v2h4v6h2V8h6V6H8z\" fill=\"#FFF\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol